export const formatEevnText = (text) => {
  if (!text) return text;
  const parts = text.split(/(eevn)/gi);
  return parts.map((part, index) =>
    part.toLowerCase() === 'eevn' ? (
      <span key={index} className="eevn-logo-text">{part}</span>
    ) : (
      part
    )
  );
};
